import React, { FC } from 'react';
import './Radio.scss';
import { Radio as AntRadio, RadioProps as AntRadioProps } from 'antd';
import { twMerge } from '@shared/utils/twMerge';

type Colors =
  | 'vividTangelo'
  | 'vermilion'
  | 'dodgerBlue'
  | 'minionYellow'
  | 'munsellPurple'
  | 'limeGreen';

type RadioProps = AntRadioProps & {
  className?: string;
  dark?: boolean;
  color?: Colors;
  children?: React.ReactNode;
};

export const Radio: FC<RadioProps> = ({ className, dark, color = 'dodgerBlue', ...props }) => {
  return (
    <AntRadio
      className={twMerge('D7-Radio', color, dark && 'dark', className)}
      {...props}
    />
  );
};
